/**
 * Theme utility functions for encounter badges and colors
 */

/**
 * Returns the color for an encounter intent badge
 */
export const getIntentColor = (intent: string): string => {
  switch (intent.toLowerCase()) {
    case 'postshift':
      return 'green'; // After shift - positive completion
    case 'preshift':
      return 'blue'; // Before shift - preparation/planning
    case 'family':
      return 'purple'; // Family communication - personal/important
    case 'checkin':
      return 'orange'; // Check-in - routine follow-up
    case 'other':
      return 'gray'; // Fallback/default
    default:
      return 'gray';
  }
};

/**
 * Returns the color for an encounter "who" badge
 */
export const getWhoColor = (who: string): string => {
  switch (who.toLowerCase()) {
    case 'aide':
      return 'blue'; // Care aide/assistant - professional care
    case 'family':
      return 'purple'; // Family member - personal/family connection
    case 'other':
      return 'gray'; // Fallback/default
    default:
      return 'gray';
  }
};
